import firebase from 'firebase'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyC4gM8ITZ6uqVbJ8flTFHj8yLoDPTsEgqw",
    authDomain: "postcastnossavoz-1f477.firebaseapp.com",
    databaseURL: "https://postcastnossavoz-1f477.firebaseio.com",
    projectId: "postcastnossavoz-1f477",
    storageBucket: "postcastnossavoz-1f477.appspot.com",
    messagingSenderId: "971549618021",
    appId: "1:971549618021:web:9b0ba5b3593fda6f56bb8c",
    measurementId: "G-2MEYHK9PXT"
};
// Initialize Firebase 

export const firebaseImpl = firebase.initializeApp(firebaseConfig);
export const firebaseDatabase = firebase.database();
export const firebaseAnalytics = firebase.analytics();
 